import { globalObject } from '@/utils/ErrorCollect/utils/getGlobal'
import { DispatchErrorCollectEvent } from '@/utils/ErrorCollect/utils/CustomErrorEvent'

// const GlobalObject = getGlobalObject()

export const debugGlobalError = () => {
    globalObject.addEventListener('error', (err) => {
        console.log('sth went wrong', err)
        DispatchErrorCollectEvent({
            ...err,
            error_type: 'WINDOW_ERROR',
        })
    }, true)
}
